export function parsePositiveInt(value) {
   const parsed = Number(value);
   if (!Number.isFinite(parsed)) return null;
   if (parsed <= 0) return null;
   return Math.trunc(parsed);
}

export function reservationIdFromAny(value) {
   if (!value || typeof value !== "object") return null;
   const id =
      value.id ??
      value._id ??
      value.reservationId ??
      value.reservation_id ??
      value.reservation?.id ??
      value.reservation?._id ??
      null;
   if (id == null) return null;
   const text = String(id).trim();
   return text || null;
}

export function reservationStartFromAny(value) {
   if (!value || typeof value !== "object") return null;
   return (
      value.startTime ??
      value.start ??
      value.start_time ??
      value.startDate ??
      value.start_date ??
      value.dateTime ??
      value.datetime ??
      value.date ??
      value.reservation?.startTime ??
      value.reservation?.start ??
      value.reservation?.start_time ??
      value.reservation?.startDate ??
      value.reservation?.start_date ??
      value.reservation?.dateTime ??
      value.reservation?.datetime ??
      value.reservation?.date ??
      null
   );
}

export function extractCreatedReservations(value) {
   if (!value) return [];
   if (Array.isArray(value)) return value;
   if (Array.isArray(value?.items)) return value.items;
   if (Array.isArray(value?.reservations)) return value.reservations;
   if (Array.isArray(value?.results)) return value.results;
   if (Array.isArray(value?.data)) return value.data;
   if (Array.isArray(value?.list)) return value.list;
   if (value?.reservation && typeof value.reservation === "object") {
      return [value.reservation];
   }
   if (typeof value === "object" && reservationIdFromAny(value)) return [value];
   return [];
}

export function getReservationStudentId(row) {
   return (
      row?.studentId ??
      row?.student_id ??
      row?.userId ??
      row?.user_id ??
      row?.student?.id ??
      row?.user?.id ??
      row?.reservation?.studentId ??
      row?.reservation?.student_id ??
      row?.reservation?.userId ??
      row?.reservation?.user_id ??
      row?.reservation?.student?.id ??
      row?.reservation?.user?.id ??
      null
   );
}

export { getReservationColumnInstructorId } from "../../utils/instructorReservations";

export function hasActiveReservationInSlot(items) {
   if (!Array.isArray(items) || !items.length) return false;
   for (const item of items) {
      if (item && item.isCanceled !== true) return true;
   }
   return false;
}
